<template>
  <div class="confirm-stage active">
    <div class="d-title">
      <span class="lbl-cap8 text-bold">Store Selected</span>
      <div class="action-edit" @click="gotoEdit()" v-if="formStore">Edit</div>
    </div>
    <div class="d-detail" v-if="formStore">
      <div class="lbl-cap6 text-bold">
        Tint World<sup>&reg;</sup> {{ formStore.address.city }}
      </div>
      <div class="lbl-cap6">
        {{ formStore.address.street }}, Suite #{{ formStore["location-id"] }}
      </div>
      <div class="lbl-cap6">
        {{ formStore.address.city }},
        {{ formStore.address.region }}
        {{ formStore.address.postalCode }}
      </div>
    </div>
    <div v-else>
      <p class="error text-danger">You must select a store to continue</p>
    </div>
  </div>
</template>
<script>
export default {
  data: () => {
    return {};
  },
  props: {},
  computed: {
    formStore() {
      return this.$store.state.user.selectedStoreForInquiry;
    },
  },
  methods: {
    gotoEdit() {
      // appt_store | appt_service | appt_date | appt_contact | appt_confirm
      this.$emit("gotoEdit");
    },
  },
};
</script>
